import * as THREE from "three";
// import { filter, Subject } from "rxjs";
import { ReactiveSet, memo } from "@apendua/signal";
import { XREventMap } from "@apendua/freedom";
import { Polyhedron } from "@apendua.dev/polytope";

// interface Updated<K> {
//   type: "updated";
//   key: K;
// }

// type GroupEvent = Updated<"transform">;

interface BasePuzzle {
  getPiece(key: string): Polyhedron;
}

export default class PuzzleGroup {
  #pieces: ReactiveSet<string>;
  #object: THREE.Group<XREventMap>;
  #puzzle: BasePuzzle;
  // #events = new Subject<GroupEvent>();

  constructor(puzzle: BasePuzzle) {
    this.#pieces = new ReactiveSet();
    this.#object = new THREE.Group();
    this.#puzzle = puzzle;
  }

  get pieces() {
    return this.#pieces;
  }

  get object() {
    return this.#object;
  }

  @memo()
  get center() {
    const center = new THREE.Vector3();
    let totalWeight = 0;
    for (const key of this.#pieces.values()) {
      const polyhedron = this.#puzzle.getPiece(key);
      const weight = polyhedron.nVertices;
      center.addScaledVector(polyhedron.getCenter(), weight);
      totalWeight += weight;
    }
    if (totalWeight > 0) {
      center.divideScalar(totalWeight);
    }
    return center;
  }
}
